/*
 * @description:  环境变量的引用，直接使用vue cli自带的env文件，没办法将变量提取出来
 *                这里使用通过一个js文件引用，其他代码使用都通过此文件使用环境变量，部署环境可以实现动态修改
 *
 * @author:
 * @since:
 * @version: 1.0
 */
export default {
  baseUrl: process.env.VUE_APP_BASE_URL,
  baseApi: process.env.VUE_APP_BASE_API
}
